import { tenantApi } from '@/modules/tenant/services/tenantApi';
import type { CreateVocabularyTermInput, VocabularyReviewItem, VocabularyTerm } from '@/modules/core/types/vocabulary.types';

export const vocabularyApi = {
  // --- Curation (Slice E5b-1; gated /vocabulary-terms endpoints) ---
  listTerms: (params?: { field?: string; needs_review?: boolean; is_active?: boolean; search?: string }) =>
    tenantApi.getList<VocabularyTerm>('/vocabulary-terms', params ? { params } : undefined),

  createTerm: (payload: CreateVocabularyTermInput) =>
    tenantApi.postOne<VocabularyTerm>('/vocabulary-terms', payload),

  updateTerm: (id: string, payload: Partial<Pick<VocabularyTerm, 'label' | 'aliases' | 'sort_order' | 'is_active'>>) =>
    tenantApi.patchOne<VocabularyTerm>(`/vocabulary-terms/${id}`, payload),

  approveTerm: (id: string) =>
    tenantApi.postOne<VocabularyTerm>(`/vocabulary-terms/${id}/approve`),

  deleteTerm: (id: string) =>
    tenantApi.deleteOne(`/vocabulary-terms/${id}`),

  // --- Review queue (Slice E5b-2; gated /vocabulary-review endpoints) ---
  listReview: (params?: { field?: string; entity_type?: string }) =>
    tenantApi.getList<VocabularyReviewItem>('/vocabulary-review', params ? { params } : undefined),

  dismissReview: (id: string) =>
    tenantApi.postOne<VocabularyReviewItem>(`/vocabulary-review/${id}/dismiss`),
};
